<template>
    <main class="about-page" aria-labelledby="about-page-title">
        <div class="about-page__inner">
            <header class="about-page__header">
                <p class="about-page__eyebrow">Веб-приложение</p>
                <h1 id="about-page-title" class="about-page__title">О приложении</h1>
                <p class="about-page__lead">
                    Аргус объединяет рабочие процессы, заявки, задачи и отчётность компании.
                </p>
            </header>

            <section class="about-page__logos" aria-label="Аргус и компания">
                <figure class="brand-card">
                    <img
                        :src="argusLogo"
                        class="brand-card__logo brand-card__logo--argus"
                        alt="Логотип Аргус"
                    >
                    <figcaption class="brand-card__caption">Аргус</figcaption>
                </figure>

                <figure v-if="showAdsLogo" class="brand-card">
                    <img
                        :src="adsLogo"
                        class="brand-card__logo brand-card__logo--ads"
                        alt="Логотип Аэродорстрой"
                    >
                    <figcaption class="brand-card__caption">
                        {{ companyName || 'Аэродорстрой' }}
                    </figcaption>
                </figure>
            </section>

            <p class="about-page__note">
                Приложение обновляется централизованно — устанавливать новую версию вручную не нужно.
            </p>
        </div>
    </main>
</template>

<script>
import argusLogo from '@/assets/logo_argus_full.png';
import adsLogo from '@/assets/logo_ads_full.png';

export default {
    name: 'About',
    data() {
        return {
            argusLogo,
            adsLogo
        };
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser || null;
        },
        showAdsLogo() {
            return Boolean(
                this.currentUser &&
                ['aerodorstroy', 'aerodorstroy_ru'].includes(this.currentUser.company)
            );
        },
        companyName() {
            return this.currentUser && this.currentUser.companyName
                ? this.currentUser.companyName
                : '';
        }
    }
};
</script>

<style scoped>
.about-page {
    min-height: 100%;
    color: #202936;
    background: #f5f7fa;
}

.about-page__inner {
    width: 100%;
    max-width: 920px;
    margin: 0 auto;
    padding: 32px 20px 96px;
}

.about-page__header {
    max-width: 640px;
    margin-bottom: 26px;
}

.about-page__eyebrow {
    margin: 0 0 5px;
    color: #697586;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.about-page__title {
    margin: 0;
    color: #17202d;
    font-size: 2rem;
    font-weight: 800;
    line-height: 1.15;
}

.about-page__lead {
    margin: 10px 0 0;
    color: #5f6b7a;
    font-size: 1.05rem;
    line-height: 1.55;
}

.about-page__logos {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
}

.brand-card {
    display: flex;
    min-height: 250px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0;
    padding: 24px;
    overflow: hidden;
    border: 1px solid #dde3ea;
    border-radius: 18px;
    background: #ffffff;
    box-shadow: 0 7px 24px rgba(31, 42, 55, 0.07);
}

.brand-card__logo {
    display: block;
    width: 100%;
    max-width: 330px;
    max-height: 190px;
    object-fit: contain;
}

.brand-card__caption {
    margin-top: 16px;
    color: #5f6b7a;
    font-size: 0.9rem;
    font-weight: 700;
    text-align: center;
}

.about-page__note {
    margin: 22px 0 0;
    padding: 14px 16px;
    border-left: 4px solid #1771ff;
    border-radius: 0 10px 10px 0;
    color: #4d5a69;
    background: #edf4ff;
    line-height: 1.45;
}

@media (max-width: 767.98px) {
    .about-page {
        min-height: calc(100vh - 56px);
        margin: 0 -0.5rem;
    }

    .about-page__inner {
        padding: 22px 14px 96px;
    }

    .about-page__title {
        font-size: 1.75rem;
    }

    .about-page__logos {
        grid-template-columns: minmax(0, 1fr);
        gap: 12px;
    }

    .brand-card {
        min-height: 210px;
        padding: 20px;
    }

    .brand-card__logo {
        max-height: 150px;
    }
}
</style>
